export const fields = [
    {id: "firstName", is_required: true},
    {id: "lastName", is_required: true},
    {id: "email", validation: (val)=>{
            if(!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(val.toLowerCase()))
                throw new Error("Invalid Email");
        }
    },
    {id: "privateStripe"}
];